<template>
    <div>
        <az-back-button :route="{name: 'credenciamentoBusca'}" text="Voltar para listagem"></az-back-button>
        <az-container>
            <credenciamento-fornecedor-acoes ref="fornecedor-acoes"></credenciamento-fornecedor-acoes>
            <div class="az-tabs">
                <v-tabs left>
                    <v-tab :to="construirRota(abas[0].nomeRota)" active-class="v-tabs__item--active secondary--text">
                        {{abas[0].titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas[1].nomeRota)" active-class="v-tabs__item--active secondary--text">
                        {{abas[1].titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas[2].nomeRota)" active-class="v-tabs__item--active secondary--text">
                      {{abas[2].titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas[3].nomeRota)" active-class="v-tabs__item--active secondary--text">
                        {{abas[3].titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas[4].nomeRota)" v-show="licitacao.status === 'ABERTO'" active-class="v-tabs__item--active secondary--text">
                      {{abas[4].titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas[5].nomeRota)" v-show="isSolicitacaoCredenciamentoEnviada" active-class="v-tabs__item--active secondary--text">
                      {{abas[5].titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas[6].nomeRota)" v-show="isSolicitacaoCredenciamentoEnviada" active-class="v-tabs__item--active secondary--text">
                      {{abas[6].titulo}}
                    </v-tab>
                </v-tabs>
                <router-view @termosAceitos="termosAceitos"></router-view>
            </div>
        </az-container>
    </div>
</template>

<script>
    import {actionTypes} from '@/commons/constants'
    import {mapActions, mapState} from 'vuex'
    import CredenciamentoFornecedorAcoes from './acoes/CredenciamentoFornecedorAcoes.vue'

    export default {
        name: 'credenciamentoFornecedor',
        components: {CredenciamentoFornecedorAcoes},
        data() {
            return {
                abas: [
                    {
                        titulo: 'Dados Gerais',
                        nomeRota: 'credenciamentoFornecedorDadosGerais'
                    },
                    {
                        titulo: 'Edital',
                        nomeRota: 'credenciamentoFornecedorEdital'
                    },
                    {
                        titulo: 'Itens',
                        nomeRota: 'credenciamentoFornecedorItens'
                    },
                    {
                      titulo: 'Esclarecimento/Impugnação',
                      nomeRota: 'credenciamentoFornecedorEsclarecimentoImpugnacao'
                    },
                    {
                        titulo: 'Documentos',
                        nomeRota: 'credenciamentoFornecedorDocumentos'
                    },
                    {
                        titulo: 'Resultado',
                        nomeRota: 'CredenciamentoFornecedorResultado'
                    },
                    {
                        titulo: 'Minhas Contratações',
                        nomeRota: 'CredenciamentoExecucaoFornecedor'
                    }
                ],
                isPropostaIniciada: false,
                licitacaoId: undefined,
                termosProposta: undefined
            }
        },
        computed: {
            ...mapState(['loki', 'termoAceiteProposta', 'licitacao', 'propostaResumo']),

          isSolicitacaoCredenciamentoEnviada() {
            return this.propostaResumo.enviada
          },
        },
        async beforeRouteUpdate(to, from, next) {
            if (this.loki.user.domainId) {
                await this.buscarDadosProposta()
            }
            next()
        },
        async created() {
            this.setLicitacaoId(this.$route.params.id)
            await this.buscarDadosProposta()
        },
        methods: {
            async termosAceitos(){
              await this.$refs["fornecedor-acoes"].buscarAceiteTermo()
            },
            construirRota(name) {
                return {
                    name,
                    params: {id: this.licitacaoId}
                }
            },
            async buscarDadosProposta() {
                this.setMensagemLoading('Carregando dados da Proposta...')
                await this.buscarPropostaResumo(this.licitacaoId)
                this.validarLicitacaoPublicada()
            },
            setLicitacaoId(licitacaoId) {
                this.licitacaoId = licitacaoId
            },
            validarLicitacaoPublicada(){
              if(!this.licitacao.publicado){
                this.$router.push({name: 'licitacaoBuscaMsg', params: {tipo: 'licitacaoexcluida'}})
              }
            },
            ...mapActions([actionTypes.BUSCAR_PROPOSTA_RESUMO])
        },
        timers: {
            buscarDadosProposta: {
                time: 30000,
                repeat: true,
                autostart: true
            }
        }
    }
</script>
